// extracted by mini-css-extract-plugin
export default {"toggleContainer":"toggleContainerw2Kvr","inputsContainer":"inputsContainerlhwjf","sectionLabel":"sectionLabelzBBY2"};